import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface SpinnerProps {
    className?: string;
    size?: "sm" | "md" | "lg";
}

export function Spinner({ className, size = "md" }: SpinnerProps): React.ReactNode {
    const sizes = {
        sm: "h-4 w-4",
        md: "h-5 w-5",
        lg: "h-8 w-8",
    } as const;
    return <Loader2 className={cn("animate-spin text-muted-foreground", sizes[size], className)} />;
}
